import Vue3Toastify, { toast } from 'vue3-toastify'
import 'vue3-toastify/dist/index.css'

// Un toast por tipo a la vez (equivalente al filterBeforeCreate previo)
const activeTypes = new Set()

// Conserva la API previa: $toast({ component, props }, options)
export const showToast = (content, options = {}) => {
  const { component, props } = content || {}
  const type = options.type || 'default'
  if (activeTypes.has(type)) {
    return
  }
  activeTypes.add(type)
  toast(component, {
    contentProps: props,
    expandCustomProps: true,
    ...options,
    type,
    onClose: (...args) => {
      activeTypes.delete(type)
      if (typeof options.onClose === 'function') {
        options.onClose(...args)
      }
    },
  })
}

export default {
  install(app) {
    app.use(Vue3Toastify, {
      autoClose: 3000,
      position: 'top-right',
      hideProgressBar: true,
      closeOnClick: false,
      closeButton: false,
      icon: false,
    })
    app.config.globalProperties.$toast = showToast
  },
}
